import type { SRT_PaginationState } from '@/shared/components/master-table'
import type { Updater } from '@tanstack/react-table'

import { useCallback, useMemo } from 'react'
import { parseAsInteger, useQueryState } from 'nuqs'

export const useWhatifRunsQueryPagination = () => {
	const [page, setPage] = useQueryState('page', parseAsInteger.withDefault(1))
	const [perPage, setPerPage] = useQueryState(
		'limit',
		parseAsInteger.withDefault(10)
	)
	const pagination: SRT_PaginationState = useMemo(
		() => ({
			pageIndex: page - 1, // zero-based index -> one-based index
			pageSize: perPage,
		}),
		[page, perPage]
	)

	const onPaginationChange = useCallback(
		(updaterOrValue: Updater<SRT_PaginationState>) => {
			if (typeof updaterOrValue === 'function') {
				const newPagination = updaterOrValue(pagination)
				void setPage(newPagination.pageIndex + 1)
				void setPerPage(newPagination.pageSize)
			} else {
				void setPage(updaterOrValue.pageIndex + 1)
				void setPerPage(updaterOrValue.pageSize)
			}
		},
		[pagination, setPage, setPerPage]
	)

	return useMemo(
		() => ({
			pagination,
			onPaginationChange,
		}),
		[pagination, onPaginationChange]
	)
}
